import React from 'react';
import { Modal as ModalComponent } from '@tvg/fuse-design';
import IconLocalOffer from '@tvg/fuse-icons/lib/LocalOffer';
import CreditToAccountPage from './pages/CreditToAccountPage';

export interface CreditToAccountDialogProps {
  dialogTitle: string;
  voucherCode: string;
  startDate: string;
  endDate: string;
  offerTerms1: string;
  offerTerms2?: string;
  offerTerms3?: string;
  offerTerms4?: string;
  open: boolean;
  onClose: () => void;
}

function CreditToAccountDialog(props: CreditToAccountDialogProps) {
  const {
    dialogTitle,
    voucherCode,
    startDate,
    endDate,
    offerTerms1,
    offerTerms2,
    offerTerms3,
    offerTerms4,
    open,
    onClose,
  } = props;

  return (
    <ModalComponent
      open={open}
      onClose={onClose}
      headerIcon={<IconLocalOffer />}
      title={dialogTitle}
      zIndex="20"
      dataTestId="cta-dialog"
      srLabelCloseButton="close cta dialog"
    >
      <CreditToAccountPage
        voucherCode={voucherCode}
        startDate={startDate}
        endDate={endDate}
        offerTerms1={offerTerms1}
        offerTerms2={offerTerms2}
        offerTerms3={offerTerms3}
        offerTerms4={offerTerms4}
      />
    </ModalComponent>
  );
}

export default CreditToAccountDialog;
